import { generateActions } from 'reducers/utils/HttpReducerHelper';

import { fundingReportsList } from './types';

const fundingReportsListHTTPActions = generateActions(fundingReportsList);
export const requestFundingReportsList = fundingReportsListHTTPActions.request;
export const requestFundingReportsListSuccess = fundingReportsListHTTPActions.success;
export const requestFundingReportsListFailure = fundingReportsListHTTPActions.failure;
